import { createPostAsyncSlice } from '@sonar-software/xuder';
import { postCustomerFeatureFlags } from '../../../../api';

export const adminCustomersFeatureFlagsPostSlice = createPostAsyncSlice({
	name: 'AdminCustomersFeatureFlags',
	receive: true,
	request: true,
	requestHandler: postCustomerFeatureFlags,
	retainDataOnRequest: false
});
